module.exports = __webpack_public_path__ + "img/chandao.e42e3e2e.png";